import React from 'react';
import TextContainer from '../TextContainer';
import { withStyles, Typography } from '@material-ui/core';
import styles from './Contacts.css';
import TextDivider from '../TextDivider';

function Contacts(props) {

    const {classes} = props;

    return (
        <div className={classes.contacts}>
            <TextContainer>
                <Typography variant="h5">For users:</Typography>
                <Typography variant="body1">
                    In case of questions, comments or errors experinced please contact <a href="mailto:nucleaizer@gmail.com">nucleaizer@gmail.com</a>.
                </Typography>

                <TextDivider></TextDivider>

                <Typography variant="h5">For collaborators and heavy users:</Typography>
                <Typography variant="body1">We offer unlimited usage for academic collaborators and industrial partners, in this case please contact us at <a href="mailto:nucleaizer@gmail.com">nucleaizer@gmail.com</a>.</Typography>

                <TextDivider></TextDivider>
                
                <Typography variant="h5">Visit our homepage:</Typography>
                <Typography variant="h5">
                    <a href="http://group.szbk.u-szeged.hu/sysbiol/horvath-peter-lab-index.html"
                        target='_blank'
                        rel="noopener noreferrer" underline="none"> 
                        <img src={process.env.PUBLIC_URL + "/BIOMAG_logo.png"} alt="BIOMAG" style={{height: '30px'}}>
                        </img>
                    </a>
                </Typography>

            </TextContainer>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Contacts);
